<template>
    <div>
        <svg style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
             version="1.1"
             viewBox="0 0 46905 17730"
             xml:space="preserve"
             xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
        >
        <text class="fil7 fnt2" text-anchor="middle" x="23400" y="865">{{ $t("header") }}</text>
            <g>
            <path class="fil0"
                  d="M20262 8217l5875 0c136,0 259,56 348,145 90,89 145,213 145,349l0 1216c0,136 -55,259 -145,349 -89,89 -212,145 -348,145l-5875 0c-136,0 -259,-56 -349,-145 -89,-90 -145,-213 -145,-349l0 -1216c0,-136 56,-260 145,-349 90,-89 213,-145 349,-145zm5875 135l-5875 0c-99,0 -188,41 -253,106 -65,65 -106,154 -106,253l0 1216c0,99 41,188 106,253 65,65 154,105 253,105l5875 0c98,0 188,-40 253,-105 65,-65 105,-154 105,-253l0 -1216c0,-99 -40,-188 -105,-253 -65,-65 -155,-106 -253,-106z"/>
                <text class="fil1 fnt0"
                      text-anchor="middle" x="23200"
                      y="9561">{{ $t("analysisStatuses.IN_SUPPORT").toUpperCase() }}</text>
        </g>
            <g>
            <rect class="fil2" height="2068" rx="453" ry="453" width="6727" x="19836" y="13820"/>
                <text class="fil4 fnt0"
                      text-anchor="middle" x="23200"
                      y="15093">{{ $t("analysisStatuses.LAB_FAILURE").toUpperCase() }}</text>
        </g>
            <g @click="goToReview" class="awaiting-review-btn">
                <rect fill="none" height="3440" rx="700" ry="700" width="6727" x="19836" y="2672"/>
                <path class="fil5"
                      d="M20530 2672l5309 0 68 0 0 67c0,182 73,346 192,464 119,119 283,192 464,192l67 0 0 68 0 1955c0,210 -85,400 -224,538 -138,138 -328,224 -538,224l-5338 0c-209,0 -400,-86 -538,-224 -138,-138 -224,-328 -224,-538l0 -1984c0,-210 86,-400 224,-538 138,-138 329,-224 538,-224zm5244 135l-5244 0c-172,0 -329,71 -442,184 -114,114 -185,271 -185,443l0 1984c0,172 71,329 185,443 113,113 270,184 442,184l5338 0c172,0 329,-71 443,-184 114,-114 184,-271 184,-443l0 -1890c-191,-16 -363,-101 -492,-229 -128,-128 -212,-300 -229,-492z"/>
                <text class="fil6 fnt0"
                      text-anchor="middle" x="23200"
                      y="4072">{{ $t("analysisStatuses.AWAITING_REVIEW").split(" ")[0].toUpperCase() }}</text>
                <text class="fil6 fnt0"
                      text-anchor="middle" x="23200"
                      y="5375">{{ $t("analysisStatuses.AWAITING_REVIEW").split(" ")[1].toUpperCase() }}</text>
            </g>
            <g>
            <text class="fil6 fnt3" text-anchor="middle"
                  x="26910"
                  v-if="statistics"
                  y="2980"
            >{{ statistics.awaitingReviewAnalysisNumber > 999 ? "999+" : statistics.awaitingReviewAnalysisNumber }}</text>
                <path class="fil5"
                      d="M26563 3531c-219,0 -417,-89 -560,-232 -143,-143 -231,-341 -231,-560 0,-218 88,-416 231,-559 143,-143 341,-232 560,-232l0 135c-181,0 -345,74 -464,193 -119,118 -192,282 -192,463 0,182 73,346 192,464 119,119 283,192 464,192l0 136z"/>
                <path class="fil5"
                      d="M27286 3395c181,0 345,-73 464,-192 119,-118 192,-282 192,-464 0,-181 -73,-345 -192,-463 -119,-119 -283,-193 -464,-193l0 -135c219,0 417,89 560,232 143,143 231,341 231,559 0,219 -88,417 -231,560 -143,143 -341,232 -560,232l0 -136z"/>
                <polygon class="fil5" points="26563,1948 27286,1948 27286,2083 26563,2083"/>
                <polygon class="fil5" points="26563,3395 27286,3395 27286,3531 26563,3531"/>
        </g>
            <g>
            <rect class="fil1" height="2068" rx="700" ry="700" width="6727" x="9694" y="13784"/>
                <text class="fil4 fnt0"
                      text-anchor="middle" x="13100" y="15060">{{ $t("analysisStatuses.ERROR").toUpperCase() }}</text>
        </g>
            <g>
            <path class="fil0"
                  d="M10120 3324l5875 0c136,0 259,56 349,145 89,90 145,213 145,349l0 1216c0,136 -56,259 -145,349 -90,89 -213,145 -349,145l-5875 0c-136,0 -259,-56 -349,-145 -89,-90 -144,-213 -144,-349l0 -1216c0,-136 55,-259 144,-349 90,-89 213,-145 349,-145zm5875 135l-5875 0c-98,0 -188,41 -253,106 -65,65 -105,154 -105,253l0 1216c0,99 40,188 105,253 65,65 155,106 253,106l5875 0c99,0 188,-41 253,-106 65,-65 105,-154 105,-253l0 -1216c0,-99 -40,-188 -105,-253 -65,-65 -154,-106 -253,-106z"/>
                <text class="fil1 fnt0"
                      text-anchor="middle" x="13100" y="4668">{{ $t("analysisStatuses.RUNNING").toUpperCase() }}</text>
        </g>
            <g>
            <text class="fil7 fnt1"
                  text-anchor="middle" x="3000"
                  y="8900">{{ $t("dataImport").split(" ")[0].toUpperCase() }}</text>
                <text class="fil7 fnt1"
                      text-anchor="middle" x="3000"
                      y="10300">{{ $t("dataImport").split(" ")[1].toUpperCase() }}</text>
        </g>
            <polygon class="fil0"
                     points="18572,4468 17283,4468 17283,4384 18572,4384 18572,4205 18974,4426 18572,4647 "/>
            <polygon class="fil0"
                     points="28714,4468 27425,4468 27425,4384 28714,4384 28714,4205 29115,4426 28714,4647 "/>
            <polygon class="fil0"
                     points="28714,9361 27425,9361 27425,9277 28714,9277 28714,9098 29115,9319 28714,9540 "/>
            <polygon class="fil0"
                     points="18572,9361 18128,9361 18128,9277 18572,9277 18572,9098 18974,9319 18572,9540 "/>
            <polygon class="fil0"
                     points="18572,14897 18373,14897 18373,14812 18572,14812 18572,14634 18974,14854 18572,15075 "/>
            <polygon class="fil0" points="18086,14610 18086,4444 18171,4444 18171,14610 "/>
            <path class="fil0"
                  d="M18374 14897c-79,0 -151,-33 -203,-85 -53,-52 -85,-124 -85,-204l85 0c0,57 22,108 59,145 37,36 88,59 144,59l0 85z"/>
            <path class="fil0"
                  d="M12837 12520l178 0 0 -134 85 0 0 134 179 0 -221 402 -221 -402zm0 -5787l221 -402 221 402 -442 0zm178 160l85 0 0 169 -85 0 0 -169zm0 422l85 0 0 169 -85 0 0 -169zm0 423l85 0 0 169 -85 0 0 -169zm0 422l85 0 0 170 -85 0 0 -170zm0 423l85 0 0 169 -85 0 0 -169zm0 423l85 0 0 169 -85 0 0 -169zm0 422l85 0 0 169 -85 0 0 -169zm0 423l85 0 0 169 -85 0 0 -169zm0 422l85 0 0 169 -85 0 0 -169zm0 423l85 0 0 169 -85 0 0 -169zm0 422l85 0 0 170 -85 0 0 -170zm0 423l85 0 0 169 -85 0 0 -169zm0 423l85 0 0 169 -85 0 0 -169z"/>

            <g>
            <text class="fil7 fnt1"
                  text-anchor="middle" x="44000" y="8900">{{ $t("dataExport").split(" ")[0].toUpperCase() }}</text>
                <text class="fil7 fnt1"
                      text-anchor="middle" x="44000"
                      y="10300">{{ $t("dataExport").split(" ")[1].toUpperCase() }}</text>
        </g>
            <line class="fil8" x1="5434" x2="7125" y1="9317" y2="9317"/>
            <polygon class="fil9"
                     points="6723,9359 5434,9359 5434,9275 6723,9275 6723,9096 7125,9317 6723,9538 "/>
            <line class="fil8" x1="39803" x2="41493" y1="9317" y2="9317"/>
            <polygon class="fil9"
                     points="41091,9359 39803,9359 39803,9275 41091,9275 41091,9096 41493,9317 41091,9538 "/>
            <g @click="goToApprove"
               class="awaiting-approve-btn">
                <rect fill="none" height="3373" rx="700" ry="700" width="6727" x="29913" y="7640"/>
                <path class="fil10"
                      d="M30607 7560l5309 0 68 0 0 67c0,182 73,346 192,464 118,119 282,192 464,192l67 0 0 68 0 1955c0,210 -86,400 -224,538 -138,139 -328,224 -538,224l-5338 0c-209,0 -400,-85 -538,-224 -138,-138 -224,-328 -224,-538l0 -1984c0,-210 86,-400 224,-538 138,-138 329,-224 538,-224zm5244 135l-5244 0c-172,0 -329,71 -442,184 -114,114 -185,271 -185,443l0 1984c0,172 71,329 185,443 113,113 270,184 442,184l5338 0c172,0 329,-71 443,-184 113,-114 184,-271 184,-443l0 -1890c-192,-16 -364,-101 -492,-229 -128,-128 -213,-300 -229,-492z"/>
                <text class="fil11 fnt0"
                      text-anchor="middle" x="33300"
                      y="8909">{{ $t("analysisStatuses.AWAITING_APPROVE").split(" ")[0].toUpperCase() }}</text>
                <text class="fil11 fnt0"
                      text-anchor="middle" x="33300"
                      y="10212">{{ $t("analysisStatuses.AWAITING_APPROVE").split(" ")[1].toUpperCase() }}</text>
            </g>
            <g>
                <rect class="fil2" height="3373" rx="700" ry="700" width="6727" x="29913" y="13168"/>
                <text class="fil4 fnt0"
                      text-anchor="middle" x="33300"
                      y="14449">{{ $t("analysisStatuses.TYPING_FAULT").split(" ")[0].toUpperCase() }}</text>
                <text class="fil4 fnt0"
                      text-anchor="middle" x="33300"
                      y="15752">{{ $t("analysisStatuses.TYPING_FAULT").split(" ")[1].toUpperCase() }}</text>
                    </g>
            <g>
            <rect class="fil6" height="2068" rx="700" ry="700" width="6727" x="29977" y="3392"/>
                <text class="fil4 fnt0"
                      text-anchor="middle" x="33300"
                      y="4668">{{ $t("analysisStatuses.COMPLETED").toUpperCase() }}</text>
            </g>
            <polygon class="fil0"
                     points="33383,6471 33383,7083 33299,7083 33299,6471 33120,6471 33341,6069 33562,6471 "/>
            <polygon class="fil0"
                     points="33299,12186 33299,11573 33383,11573 33383,12186 33562,12186 33341,12588 33120,12186 "/>
            <path class="fil0"
                  d="M7945 17644l84 0 0 85 -84 0 0 -85zm0 -17241l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 170l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 170l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 169l84 0 0 85 -84 0 0 -85zm0 170l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84zm0 169l84 0 0 84 -84 0 0 -84z"/>
            <path class="fil0"
                  d="M8028 17643l0 85 -85 0 0 -85 85 0zm507 0l0 85 -85 0 0 -85 85 0zm-169 0l0 85 -85 0 0 -85 85 0zm-169 0l0 85 -85 0 0 -85 85 0z"/>
            <path class="fil0"
                  d="M8028 396l0 84 -85 0 0 -84 85 0zm507 0l0 84 -85 0 0 -84 85 0zm-169 0l0 84 -85 0 0 -84 85 0zm-169 0l0 84 -85 0 0 -84 85 0z"/>
            <path class="fil0"
                  d="M38898 17644l85 0 0 85 -85 0 0 -85zm0 -17241l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 170l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 170l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 169l85 0 0 85 -85 0 0 -85zm0 170l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 84 -85 0 0 -84zm0 169l85 0 0 85 -85 0 0 -85z"/>
            <path class="fil0"
                  d="M38899 480l0 -84 85 0 0 84 -85 0zm-507 0l0 -84 85 0 0 84 -85 0zm169 0l0 -84 85 0 0 84 -85 0zm169 0l0 -84 85 0 0 84 -85 0z"/>
            <path class="fil0"
                  d="M38896 17730l0 -84 85 0 0 84 -85 0zm-507 0l0 -84 85 0 0 84 -85 0zm169 0l0 -84 85 0 0 84 -85 0zm169 0l0 -84 85 0 0 84 -85 0z"/>
            <polygon class="fil0"
                     points="23157,7290 23157,6678 23242,6678 23242,7290 23420,7290 23199,7692 22978,7290 "/>
            <g>
            <text class="fil11 fnt3" text-anchor="middle"
                  x="37050"
                  v-if="statistics"
                  y="7860"
            >{{ statistics.awaitingCustomerAnalysisNumber > 999 ? "999+" : statistics.awaitingCustomerAnalysisNumber }}</text>
                <path class="fil10"
                      d="M36640 8419c-219,0 -417,-89 -560,-232 -143,-143 -232,-341 -232,-560 0,-218 89,-416 232,-559 143,-143 341,-232 560,-232l0 136c-182,0 -346,73 -464,192 -119,118 -192,282 -192,463 0,182 73,346 192,464 118,119 282,192 464,192l0 136z"/>
                <path class="fil10"
                      d="M37363 8283c181,0 345,-73 464,-192 119,-118 192,-282 192,-464 0,-181 -73,-345 -192,-463 -119,-119 -283,-192 -464,-192l0 -136c219,0 416,89 560,232 143,143 231,341 231,559 0,219 -88,417 -231,560 -144,143 -341,232 -560,232l0 -136z"/>
                <polygon class="fil10" points="36640,6836 37363,6836 37363,6972 36640,6972 "/>
                <polygon class="fil10" points="36640,8283 37363,8283 37363,8419 36640,8419 "/>
        </g>
</svg>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import { Locales } from "@/i18n/main"

    export default {
        name: "WorkflowScheme",
        computed: {
            ...mapGetters({
                statistics: "organizationStatistics"
            })
        },
        methods: {
            goToReview() {
                this.$router.push({ name: "analysesReview" })
            },
            goToApprove() {
                this.$router.push({ name: "approve" })
            }
        },
        i18n: {
            messages: {
                [Locales.EN]: {
                    header: "TYPING WORKFLOW",
                    dataImport: "Data import",
                    dataExport: "Data export"
                },
                [Locales.RU]: {
                    header: "СХЕМА АНАЛИЗА ОБРАЗЦА",
                    dataImport: "Импорт данных",
                    dataExport: "Экспорт данных"
                }
            }
        }

    }
</script>

<style scoped>

    .fil8 {
        fill: none
    }

    .fil6 {
        fill: #5CB85C
    }

    .fil7 {
        fill: #666666
    }

    .fil1 {
        fill: var(--grey-400)
    }

    .fil2 {
        fill: var(--red)
    }

    .fil11 {
        fill: var(--yellow)
    }

    .fil4 {
        fill: white
    }

    .fil5 {
        fill: #5CB85C;
        fill-rule: nonzero
    }

    .fil9 {
        fill: #666666;
        fill-rule: nonzero
    }

    .fil0 {
        fill: var(--grey-400);
        fill-rule: nonzero
    }

    .fil3 {
        fill: var(--red);
        fill-rule: nonzero
    }

    .fil10 {
        fill: var(--yellow);
        fill-rule: nonzero
    }

    .fnt3 {
        font-weight: bold;
        font-size: 70rem;
    }

    .fnt0 {
        font-weight: bold;
        font-size: 70rem;
    }

    .fnt2 {
        font-weight: normal;
        font-size: 118rem;
    }

    .fnt1 {
        font-weight: bold;
        font-size: 90rem;
    }

    .awaiting-review-btn:hover,
    .awaiting-approve-btn:hover {
        cursor: pointer;
    }

    .awaiting-review-btn:hover > rect {
        fill: hsl(75, 100%, 95%);
    }

    .awaiting-approve-btn:hover > rect {
        fill: hsl(48, 100%, 95%);
    }
</style>
